import { Button, Form, Input, Space } from 'antd';
import { FC } from 'react';

import { ButtonSuccess } from '@/common/components';
import { AppFormProps } from '@/common/interfaces';
import { defineInputStatus } from '@/common/utils';

import { SiteFormFields, SiteFormInputs } from '@/modules/Sites/';


interface Props extends AppFormProps<typeof SiteFormInputs, SiteFormFields> {}

export const SitesFormView: FC<Props> = ({
  formName,
  form,
  formType,
  initialValues,
  isFormLoading,
  validationSchema,
  formErrors,
  handleFinish,
  handleBack,
  handleFinishFailed
}) => {
  return (
    <Form
      form={ form }
      name={ formName }
      layout="vertical"
      initialValues={ initialValues }
      autoComplete="off"
      onFinish={ handleFinish }
      onFinishFailed={ handleFinishFailed }
    >
      <Form.Item
        label="Назва"
        name={ SiteFormInputs.Name }
        hasFeedback
        help={ formErrors?.name }
        validateStatus={ defineInputStatus(isFormLoading, formErrors?.name) }
        rules={ validationSchema.name }
      >
        <Input disabled={ isFormLoading } allowClear/>
      </Form.Item>

      <Form.Item wrapperCol={{ span: 24 }}>
        <Space align="center" style={{ width: '100%', justifyContent: 'flex-end' }}>
          <Button disabled={ isFormLoading } type="default" onClick={ handleBack }>
            Скасувати
          </Button>
          <ButtonSuccess loading={ isFormLoading } type="primary" htmlType="submit">
            { formType === 'edit' ? 'Зберегти' : 'Створити' }
          </ButtonSuccess>
        </Space>
      </Form.Item>
    </Form>
  );
};
